module.exports = {
      id: "mkb-sustainability-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#mkb-sustainability",
      toString: function () {
        return this.url;
      }
    }